var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"embeddedWeb"}},[(_vm.loaded)?_c('iframe',{attrs:{"id":"iframe","src":_vm.resuouce}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }